import React, { Fragment, useState } from "react"
import { navigate } from "gatsby"
import { PrimaryButton } from "../Button/Button"
import navOpener from "../../assets/new_images/opener.svg"
import navLogo from "../../assets/new_images/logo.png"
import navClose from "../../assets/new_images/close.svg"
import Drawer from "react-modern-drawer"
import "react-modern-drawer/dist/index.css"
import "./Navbar.css"
import { Link } from "gatsby"
import apaceLogo from "../../images/apace Logo_Main Logo.svg"
import hamburger from "../../images/hambuegr.svg"
import { HiExternalLink } from "react-icons/hi"

const Navbar = ({ bgColor, borderColor }) => {
  let [linksOpener, setLinkOpenner] = useState(false)
  const [isOpen, setIsOpen] = React.useState(false)
  const [activeMenu, setactive] = React.useState(false)

  const toggleDrawer = () => {
    setIsOpen(prevState => !prevState)
  }

  function openMobileLinks() {
    setLinkOpenner(!linksOpener)
  }
  return (
    <Fragment>
      <div
        className="main_navbar_container "
        style={bgColor && { background: bgColor, borderBottom: borderColor }}
      >
        <div className="navbar_container custom_main_container">
          <div className="navbar_mob_links" onClick={openMobileLinks}>
            <img src={navOpener} alt="opener" onClick={toggleDrawer} />
            <div className="mob_navbar_logo">
              <img onClick={() => navigate("/")} src={navLogo} alt="logo" />
            </div>
            <div className="btn_container for-business">
              <Link to="/">
                <PrimaryButton>
                  For Business <HiExternalLink className="icon" />
                </PrimaryButton>
              </Link>
            </div>
          </div>
          <div className="navbar_logo">
            <img onClick={() => navigate("/")} src={navLogo} alt="logo" />
          </div>
          <div className="navbar_links">
            <p onClick={() => navigate("/shoppers")}>Home</p>
            <p onClick={() => navigate("/shoppers#how-it-works")}>
              How it works
            </p>
            <p onClick={() => navigate("/shoppers#why-apace")}>Why apace?</p>
            <p onClick={() => navigate("/shoppers/about")}>About</p>
            <p onClick={() => navigate("/shoppers#faqs")}>FAQ</p>
            <div className="btn_container for-business">
              <Link to="/">
                <PrimaryButton>
                  For Business <HiExternalLink className="icon" />
                </PrimaryButton>
              </Link>
            </div>
          </div>
        </div>
      </div>
      <Drawer open={isOpen} onClose={toggleDrawer} direction="right">
        <div className="flex flex-col  py-4">
          <Link to="/" className="">
            <img
              src={navLogo}
              alt="apace"
              className="w-[200px] mb-10 m-3 mt-10"
            />
          </Link>
          <div>
            <div
              className="flex justify-between relative mb-4 cursor-pointer px-4"
              onClick={() => setactive(!activeMenu)}
            >
              <p
                onClick={() => {
                  navigate("/shoppers")
                  setIsOpen(false)
                }}
              >
                Home
              </p>
            </div>
            <div
              className="flex justify-between relative mb-4 cursor-pointer px-4"
              onClick={() => setactive(!activeMenu)}
            >
              <p
                onClick={() => {
                  navigate("/shoppers#how-it-works")
                  setIsOpen(false)
                }}
              >
                How it works
              </p>
            </div>
            <div
              className="flex justify-between relative mb-4 cursor-pointer px-4"
              onClick={() => setactive(!activeMenu)}
            >
              <p
                onClick={() => {
                  setIsOpen(false)
                  navigate("/shoppers#why-apace")
                }}
              >
                Why apace?
              </p>
            </div>
            <div
              className="flex justify-between relative mb-4 cursor-pointer px-4"
              onClick={() => setactive(!activeMenu)}
            >
              <p
                onClick={() => {
                  setIsOpen(false)
                  navigate("/shoppers/about")
                }}
              >
                About
              </p>
            </div>
            <div
              className="flex justify-between relative mb-4 cursor-pointer px-4"
              onClick={() => setactive(!activeMenu)}
            >
              <p
                onClick={() => {
                  setIsOpen(false)
                  navigate("/shoppers#faqs")
                }}
              >
                FAQ
              </p>
            </div>
          </div>
        </div>
      </Drawer>
    </Fragment>
  )
}

export default Navbar
